import { BoxProps } from "@mui/material";
import {
  FlatPageRouteControl,
  FlatPageRouteTab,
} from "@app/components/FlatPageRouteControl";
import { useMemo } from "react";
import { SimulationDetailsSummary } from "./SimulationDetailsSummary";
import { SimulationCorrelations } from "./SimulationCorrelations";
import { SimulationReturns } from "./SimulationReturns";
import { SimulationYields } from "./SimulationYields";
import { SimulationDataExplorer } from "./SimulationDataExplorer";
import { SimulationDistanceFromTrend } from "./SimulationDistanceFromTrend";
import { SimulationSimulatedForwardProbabilities } from "./SimulationSimulatedForwardProbabilities";
import { CarModuleSectionCode } from "@app/hooks/useUserAccess";

interface SimulationDetailsProps {
  sx?: BoxProps["sx"];
  simulationJobId: string;
  isStatic: boolean;
}

export const SimulationDetails = (props: SimulationDetailsProps) => {
  const tabs = useMemo(() => {
    const tabs: Array<FlatPageRouteTab> = props.isStatic
      ? [
          {
            url: "summary",
            label: "Summary",
            moduleSection:
              CarModuleSectionCode.SIMULATION_ANALYSIS_STATIC_SUMMARY,
            content: (
              <SimulationDetailsSummary
                simulationJobId={props.simulationJobId}
                isStatic={props.isStatic}
              />
            ),
          },

          {
            url: "simulated-forward-probabilities",
            label: "Simulated Forward Probabilities",
            moduleSection:
              CarModuleSectionCode.SIMULATION_ANALYSIS_STATIC_SIMULATED_FORWARD_PROBABILITIES,
            content: (
              <SimulationSimulatedForwardProbabilities
                simulationJobId={props.simulationJobId}
              />
            ),
          },
          {
            url: "returns",
            label: "Returns",
            moduleSection:
              CarModuleSectionCode.SIMULATION_ANALYSIS_STATIC_RETURNS,
            content: (
              <SimulationReturns
                simulationJobId={props.simulationJobId}
                isStatic={props.isStatic}
              />
            ),
          },
          {
            url: "data-explorer",
            label: "Data Explorer",
            moduleSection:
              CarModuleSectionCode.SIMULATION_ANALYSIS_STATIC_DATA_EXPLORER,
            content: (
              <SimulationDataExplorer simulationJobId={props.simulationJobId} />
            ),
          },
          {
            url: "correlations",
            label: "Correlations",
            moduleSection:
              CarModuleSectionCode.SIMULATION_ANALYSIS_STATIC_CORRELATIONS,
            content: (
              <SimulationCorrelations
                simulationJobId={props.simulationJobId}
                isStatic={props.isStatic}
              />
            ),
          },
        ]
      : [
          {
            url: "summary",
            label: "Summary",
            moduleSection:
              CarModuleSectionCode.SIMULATION_ANALYSIS_PRICE_DRIVEN_SUMMARY,
            content: (
              <SimulationDetailsSummary
                simulationJobId={props.simulationJobId}
                isStatic={props.isStatic}
              />
            ),
          },
          {
            url: "distance-from-trend",
            label: "Distance From Trend",
            moduleSection:
              CarModuleSectionCode.SIMULATION_ANALYSIS_PRICE_DRIVEN_DISTANCE_FROM_TREND,
            content: (
              <SimulationDistanceFromTrend
                simulationJobId={props.simulationJobId}
              />
            ),
          },
          {
            url: "simulated-forward-probabilities",
            label: "Simulated Forward Probabilities",
            moduleSection:
              CarModuleSectionCode.SIMULATION_ANALYSIS_PRICE_DRIVEN_SIMULATED_FORWARD_PROBABILITIES,
            content: (
              <SimulationSimulatedForwardProbabilities
                simulationJobId={props.simulationJobId}
              />
            ),
          },
          {
            url: "returns",
            label: "Returns",
            moduleSection:
              CarModuleSectionCode.SIMULATION_ANALYSIS_PRICE_DRIVEN_RETURNS,
            content: (
              <SimulationReturns
                simulationJobId={props.simulationJobId}
                isStatic={props.isStatic}
              />
            ),
          },
          {
            url: "yields",
            label: "Yields",
            moduleSection:
              CarModuleSectionCode.SIMULATION_ANALYSIS_PRICE_DRIVEN_YIELDS,
            content: (
              <SimulationYields simulationJobId={props.simulationJobId} />
            ),
          },
          {
            url: "data-explorer",
            label: "Data Explorer",
            moduleSection:
              CarModuleSectionCode.SIMULATION_ANALYSIS_PRICE_DRIVEN_DATA_EXPLORER,
            content: (
              <SimulationDataExplorer simulationJobId={props.simulationJobId} />
            ),
          },
          {
            url: "correlations",
            label: "Correlations",
            moduleSection:
              CarModuleSectionCode.SIMULATION_ANALYSIS_PRICE_DRIVEN_CORRELATIONS,
            content: (
              <SimulationCorrelations
                simulationJobId={props.simulationJobId}
                isStatic={props.isStatic}
              />
            ),
          },
        ];

    return tabs;
  }, [props.isStatic, props.simulationJobId]);
  return <FlatPageRouteControl tabs={tabs} sx={props.sx} />;
};
